<template>
  <div class="login_container">
    <el-dialog title="选择角色" :visible.sync="showDialog" width="30%" center>
      <changeRole :visible.sync="showDialog"></changeRole>
    </el-dialog>
    <div class="login_box" style="">
      <!--头像区域-->
      <div class="avatar_box">
        <img src="@/assets/img/logo.png" alt />
      </div>
      <!--表单区域-->
      <el-form ref="formRef" :model="form" :rules="rules" label-width="0px" class="login_form">
        <el-form-item prop="dlmc">
          <el-input prefix-icon="el-icon-user" placeholder="用户名" v-model="form.dlmc"></el-input>
        </el-form-item>
        <el-form-item prop="yhmm">
          <el-input prefix-icon="el-icon-lock" placeholder="密码" v-model="form.yhmm" show-password></el-input>
        </el-form-item>
        <el-form-item style="text-align:center;">
          <el-button type="primary" @click="submitLogin" style="width:80%; font-size:20px;">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { login } from '@/api/baseApi'
import { toMyExam } from '@/api/examinee'
import changeRole from '@/components/changeRole'
export default {
  name: 'Login',
  data () {
    return {
      // 登录表单的数据绑定对象
      form: {
        dlmc: '',
        yhmm: ''
      },
      showDialog: false, // 显示角色切换窗
      // 表单的验证规则对象
      rules: {
        dlmc: [
          { required: true, message: '请输入登录名称', trigger: 'blur' },
          { min: 5, max: 10, message: '长度在 5 到 10 个字符', trigger: 'blur' }
        ],
        yhmm: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    changeRole
  },
  methods: {
    toExaminee () {
      toMyExam(null).then(res => {
        this.$http.callback(res, () => {
          this.$store.commit('mobile/setUser', res.data.user)
          this.$store.commit('mobile/setToken', res.data.token)
          this.$store.commit('mobile/setAuth', res.data.auth)
          this.$router.push({
            path: '/examinee/list'
          })
        })
      })
    },
    submitLogin () {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          const params = Object.assign({}, this.form)
          params.dlmc = this.$utils.encryptByPublicKey(params.dlmc + '?ct=' + new Date().getTime())
          params.yhmm = this.$utils.encryptByPublicKey(params.yhmm + '?ct=' + new Date().getTime())
          login(params).then(res => {
            this.$http.callback(res, () => {
              this.$store.commit('setUser', res.data.user)
              this.$store.commit('setToken', res.data.token)
              const xtbAqjsList = res.data.user.xtbAqjsList
              if (Array.isArray(xtbAqjsList) && xtbAqjsList.length > 1) {
                // 选择角色
                this.showDialog = true
              } else {
                if ('0,1,2,3'.indexOf(this.$store.state.user.jslx) !== -1) {
                  this.$router.push({
                    path: '/'
                  })
                } else {
                  this.toExaminee() // 没有管理员角色，直接进入考生中心
                }
              }
            })
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.login_container {
  height: 100%;
  background: #2b4b6b;
}
.login_box {
  width: 450px;
  height: 300px;
  background: #fff;
  border-radius: 3px;
  position: absolute;
  left: 50%;
  top: 300px;
  transform: translate(-50%, -50%);

  .avatar_box {
    padding: 10px;
    width: 250px;
    height: 200;
    border: 1px solid #eee;
    border-radius: 50%;
    box-shadow: 0 0 10px #ddd;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.login_form {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
